import { Box, Grid, type SxProps, type Theme } from '@mui/material'
import React, { type FC } from 'react'

import { isArrayNotEmpty } from '../../../../utils'

import { type CybusDetailedService, Translation } from '../../../../domain'

import { Status } from '../../common'
import { DetailsEntry } from '../../Details'
import { useTranslator } from '../../Internationalization'
import { ServiceLinks } from '../Links'
import { CrossReferenceServiceLinks } from '../ServiceLink'

const logoWrapperStyle: SxProps<Theme> = { my: 'auto', mr: 2, textAlign: 'center' }
const logoStyle: SxProps<Theme> = { maxWidth: '100%' }
const infoStyle: SxProps<Theme> = { px: 1, flexGrow: 1, mb: 2 }
const preformattedStyle: SxProps<Theme> = { whiteSpace: 'pre-wrap' }

export const HeaderDetails: FC<{ resource: CybusDetailedService }> = ({ resource: service }) => {
    const translator = useTranslator()

    return (
        <Grid container justifyContent="space-between">
            <Grid data-testid="service-header-description" sx={infoStyle} size={{ xs: service.icon ? 7 : 9 }}>
                <DetailsEntry title={Translation.SERVICE_ID} type="text">
                    {service.id}
                </DetailsEntry>
                <DetailsEntry title={Translation.NAME} type="text">
                    {service.name}
                </DetailsEntry>
                <DetailsEntry title={Translation.DESCRIPTION}>
                    <Box sx={preformattedStyle}>{service.description}</Box>
                </DetailsEntry>
                {service.provider && (
                    <DetailsEntry title={Translation.PROVIDER} type="text">
                        {service.provider}
                    </DetailsEntry>
                )}
                {service.version && <DetailsEntry title={Translation.VERSION}>{service.version}</DetailsEntry>}
                <DetailsEntry title={Translation.STATUS}>
                    <Status status={service.status} />
                </DetailsEntry>
                <DetailsEntry title={Translation.DEVIATION}>
                    <Status status={service.deviation} />
                </DetailsEntry>
                {isArrayNotEmpty(service.links)
                    ? (
                        <DetailsEntry title={translator.formatTranslation(Translation.LINK, { count: service.links.length })}>
                            <ServiceLinks links={service.links} isDetailedView />
                        </DetailsEntry>
                    )
                    : null}
                {isArrayNotEmpty(service.dependencies.dependent) && (
                    <CrossReferenceServiceLinks
                        data-testid="dependent-services"
                        title={Translation.REQUIRED_BY}
                        services={service.dependencies.dependent}
                    />
                )}
                {isArrayNotEmpty(service.dependencies.dependsOn) && (
                    <CrossReferenceServiceLinks
                        data-testid="depends-on-services"
                        title={Translation.DEPENDS_ON_SERVICES}
                        services={service.dependencies.dependsOn}
                    />
                )}
            </Grid>

            {service.icon && (
                <Grid size={{ xs: 2 }} sx={logoWrapperStyle}>
                    <Box component="img" src={service.icon} sx={logoStyle} />
                </Grid>
            )}
        </Grid>
    )
}
